import React, { useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

import './Accordion.css'

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="detail-accordion-item-wrapper">
      <div className="detail-accordion-title" onClick={() => setOpen(!open)}>
        <div>
          <p className="mb--0">{title}</p>
        </div>
        <div>
          <span className={`text--color-gold ${open ? 'detail-accordion-icon-open' : null}`}>
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </div>
      </div>
      <div className={`detail-accordion-body ${open ? 'open' : null}`}>
        { children }
      </div>
    </div>
  )
}

export default Accordion